import { Socket } from '@nutshell/core';

class VueSocket extends Socket {

    /**
     * Add function to the list of listeners. If the given eventname is equal to the received eventname, the function will be triggered.
     *
     * @param {String} event
     * @param {Function} listener
     * @param {VueComponent} component
     */
    on(event, listener, component) {

        if ( typeof listener == 'function' ) {

            this.listeners.push({
                event,
                listener,
                component
            });
        }
    }

    /**
     * Remove event listeners of component
     *
     * @param {VueComponent} component
     */
    clear(component) {

        const removal = [];

        /**
         * Collect all event for removal based on the component.
         */
        this.listeners.forEach( (listener, index) => {

            if ( listener.component == component ) {
                removal.unshift(index);
            }
        });

        /**
         * Remove all listeners based on collected indexes. Always remove the biggest index first.
         */
        removal.forEach( (index) => {
            this.listeners.splice(index,1);
        });
    }

}

/**
 * Installing the VueSocket as a plugin for Vue
 * @param  {Vue} Vue
 */
VueSocket.install = (Vue) => {

    Vue.mixin({

        /**
         * Find the socket class and add as variabele to the component for easy access
         * Also autoconnect with socket.
         */
        beforeCreate () {

            if ( this.$options.socket instanceof VueSocket ) {
                this._socket = this.$options.socket;
            }
            else {
                this._socket = (this.$parent && this.$parent._socket) || this;
            }
        },

        /**
         * Check if the component has a object with events. If so, add the events to the socket event listeners.
         */
        created() {

            if ( this._socket && this.$options.events && typeof this.$options.events == 'object' ) {

                const events = Object.keys(this.$options.events);

                events.forEach( ( event ) => {

                    if ( typeof this.$options.events[event] == 'function' ) {
                        this._socket.on(event, this.$options.events[event], this);
                    }

                });
            }
        },

        /**
         * Before destroying the vue component, remove all event listeners of this component
         * @return {[type]} [description]
         */
        beforeDestroy() {

            if ( this._socket ) {
                this._socket.clear(this);
            }
        }

    });

    Object.defineProperty(Vue.prototype, '$socket', {
        get () { return this._socket; }
    });
}

export default VueSocket;
